import { render } from "./StationParent.vue?vue&type=template&id=bb2ff876&scoped=true"
import script from "./StationParent.vue?vue&type=script&lang=js"
export * from "./StationParent.vue?vue&type=script&lang=js"

import "./StationParent.vue?vue&type=style&index=0&id=bb2ff876&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb2ff876"]])

export default __exports__